import React, { useRef, useState } from 'react';

import Slider from 'react-slick';
import randomColor from 'randomcolor';
import { Button, Dialog, DialogActions } from '@material-ui/core';
import { DialogContent, DialogTitle } from '@material-ui/core';

import API from 'utils/api';
import { useDialog, useSources } from 'hooks';
import { Progress } from 'components';
import { call, classes } from 'utils';

import PieChartAnalytics from '../../../Analytics/components/PieChartAnalytics';

import styles from './AnalyticsDialog.module.scss';

const AnalyticsDialog = ({ interactionId, onMessage, onClose }) => {
  const [state, setState] = useState();

  const graph = useRef([]);
  const sources = useSources();

  const { title = '', questions = [] } = state || {};

  const { isOpening } = useDialog(interactionId, {
    onOpen: () => {
      setState(null);

      API.getInteractionStatistics({ interaction: interactionId }, sources).then(
        ({ data }) =>
          data
            ? setState({
                title: data.title,
                questions: (data.data || []).filter(
                  it => it.type === 'defaultQuestion' && it.questionHasData
                ),
              })
            : null
      );
    },

    onClose: () => sources.cancelAll(),
  });

  const send = () => {
    const data = graph.current.map((it, index) => {
      const chart = it.querySelector('#chartResponsive');

      if (chart && chart.firstElementChild) {
        const {
          questionTitle: title,
          totalCorrectAnswers = 0,
          totalWrongAnswers = 0,
          options = [],
        } = questions[index];

        const total = totalCorrectAnswers + totalWrongAnswers;

        return {
          title,
          html: chart.firstElementChild.outerHTML,
          options: options.map((it, index) => ({
            index: it.index,
            title: it.title,
            totalPercentage: total ? (100 * it.total) / total : 0,
            color: it.index === -1 ? '#d9dbde' : randomColor({ seed: index * 20 }),
          })),
        };
      }

      return null;
    });

    call(onMessage, 'statistics', { arrayObjChart: data.filter(it => !!it) });
  };

  const status = isOpening || !state ? 'loading' : questions.length ? 'active' : 'idle';

  return (
    <Dialog open={!!interactionId} onClose={onClose} classes={{ paper: styles.dialog }}>
      <DialogTitle className={styles.header}>{title}</DialogTitle>

      <DialogContent className={classes(styles.body, styles[status])}>
        {status === 'active' ? (
          <Slider dots>
            {questions.map((it, index) => (
              <div
                className={styles.item}
                key={index}
                ref={ref => (graph.current[index] = ref)}
              >
                <div>
                  <PieChartAnalytics question={it} preview />
                </div>
              </div>
            ))}
          </Slider>
        ) : status === 'idle' ? (
          <div className={styles.empty}>No records to display</div>
        ) : (
          <Progress />
        )}
      </DialogContent>

      <DialogActions className={styles.footer}>
        <Button onClick={onClose}>Close</Button>

        {status === 'active' ? (
          <Button onClick={send} variant="contained" color="primary" autoFocus>
            Send
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

export default AnalyticsDialog;
